import React from "react"
import Label from "@kit/design/label"
import { ColorInput } from "@kit/design/color-picker"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "../../components/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { Expander } from "app/regions/blocks/shared/expander"
import { CustomBackgroundColor } from "../../components/custom-background-color"
import { BorderSettings } from "../../components/border-settings"
import { FontSettings } from "../../../header/utils/font-settings"
import { useSavedColors } from "hooks/use-saved-colors"

export function TwoColumnsLargeCTASettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  return (
    <>
      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Left image"
          name="leftImage"
          image={properties.leftImage}
          alt={properties.leftAlt}
          update={file =>
            update({
              leftImage: file.image || properties.leftImage,
              leftAlt: file.alt
            })
          }
          remove={() => update({ leftImage: "", leftAlt: "" })}
        />
      </div>

      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Right image"
          name="rightImage"
          image={properties.rightImage}
          alt={properties.rightAlt}
          update={file =>
            update({
              rightImage: file.image || properties.rightImage,
              rightAlt: file.alt
            })
          }
          remove={() => update({ rightImage: "", rightAlt: "" })}
        />
      </div>

      <Expander className="mb-4" label="Left column">
        <CustomBackgroundColor
          properties={properties}
          update={update}
          propertyName="backgroundColorLeft"
        />

        <div>
          <Label htmlFor="headingColorLeft">Heading</Label>
          <ColorInput
            id="headingColorLeft"
            name="headingColorLeft"
            onChange={color => update({ headingColorLeft: color.hex })}
            value={properties.headingColorLeft}
            savedColors={savedColors}
          />
        </div>
        <div>
          <Label htmlFor="textColorLeft">Text</Label>
          <ColorInput
            id="textColorLeft"
            name="textColorLeft"
            onChange={color => update({ textColorLeft: color.hex })}
            value={properties.textColorLeft}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <Expander className="mb-4" label="Right column">
        <CustomBackgroundColor
          properties={properties}
          update={update}
          propertyName="backgroundColorRight"
        />

        <div>
          <Label htmlFor="headingColorRight">Heading</Label>
          <ColorInput
            id="headingColorRight"
            name="headingColorRight"
            onChange={color => update({ headingColorRight: color.hex })}
            value={properties.headingColorRight}
            savedColors={savedColors}
          />
        </div>
        <div>
          <Label htmlFor="textColorRight">Text</Label>
          <ColorInput
            id="textColorRight"
            name="textColorRight"
            onChange={color => update({ textColorRight: color.hex })}
            value={properties.textColorRight}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <Expander className="mb-4" label="Spacing">
        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <Expander label="Fonts">
        <FontSettings
          label="Heading font"
          fontFamilySetting="headingFontFamily"
          fontWeightSetting="headingFontWeight"
          properties={properties}
          update={update}
        />

        <FontSettings
          label="Text font"
          fontFamilySetting="textFontFamily"
          fontWeightSetting="textFontWeight"
          properties={properties}
          update={update}
        />
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
